import { useContext } from 'react';
import MicroFrontendPropsContext, {
	MicroFrontendProps,
} from '../../Services/ModuleService/MicroFrontendPropsContext';

const useMFEProps = (): MicroFrontendProps => useContext(MicroFrontendPropsContext);

export default useMFEProps;
